import { DefaultRootState } from 'react-redux';

import { AdditionalEducation } from 'src/models/resume/resumeCommon.types';

export const selectApplicantResumeAttestationEducation = ({
    applicantResume,
}: DefaultRootState): AdditionalEducation[] => applicantResume.attestationEducation || [];
